import { __extends } from "tslib";
import { DeleteCustomKeyStoreRequest, DeleteCustomKeyStoreResponse } from "../models/models_0";
import { deserializeAws_json1_1DeleteCustomKeyStoreCommand, serializeAws_json1_1DeleteCustomKeyStoreCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Deletes a <a href="https://docs.aws.amazon.com/kms/latest/developerguide/custom-key-store-overview.html">custom key store</a>. This operation does not delete the AWS CloudHSM cluster that is
 *       associated with the custom key store, or affect any users or keys in the cluster.</p>
 *          <p>The custom key store that you delete cannot contain any AWS KMS <a href="https://docs.aws.amazon.com/kms/latest/developerguide/concepts.html#master_keys">customer master keys (CMKs)</a>. Before
 *       deleting the key store, verify that you will never need to use any of the CMKs in the key
 *       store for any <a href="https://docs.aws.amazon.com/kms/latest/developerguide/concepts.html#cryptographic-operations">cryptographic operations</a>. Then, use <a>ScheduleKeyDeletion</a> to
 *       delete the AWS KMS customer master keys (CMKs) from the key store. When the scheduled waiting
 *       period expires, the <code>ScheduleKeyDeletion</code> operation deletes the CMKs. Then it makes
 *       a best effort to delete the key material from the associated cluster. However, you might need
 *       to manually <a href="https://docs.aws.amazon.com/kms/latest/developerguide/fix-keystore.html#fix-keystore-orphaned-key">delete the orphaned key
 *         material</a> from the cluster and its backups.</p>
 *          <p>After all CMKs are deleted from AWS KMS, use <a>DisconnectCustomKeyStore</a> to
 *       disconnect the key store from AWS KMS. Then, you can delete the custom key store.</p>
 *          <p>Instead of deleting the custom key store, consider using <a>DisconnectCustomKeyStore</a> to disconnect it from AWS KMS. While the key store is
 *       disconnected, you cannot create or use the CMKs in the key store. But, you do not need to
 *       delete CMKs and you can reconnect a disconnected custom key store at any time.</p>
 *          <p>If the operation succeeds, it returns a JSON object with no
 * properties.</p>
 *          <p>This operation is part of the <a href="https://docs.aws.amazon.com/kms/latest/developerguide/custom-key-store-overview.html">Custom Key Store feature</a> feature in AWS KMS, which
 * combines the convenience and extensive integration of AWS KMS with the isolation and control of a
 * single-tenant key store.</p>
 */
var DeleteCustomKeyStoreCommand = /** @class */ (function (_super) {
    __extends(DeleteCustomKeyStoreCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteCustomKeyStoreCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteCustomKeyStoreCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KMSClient";
        var commandName = "DeleteCustomKeyStoreCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DeleteCustomKeyStoreRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteCustomKeyStoreResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteCustomKeyStoreCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DeleteCustomKeyStoreCommand(input, context);
    };
    DeleteCustomKeyStoreCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DeleteCustomKeyStoreCommand(output, context);
    };
    return DeleteCustomKeyStoreCommand;
}($Command));
export { DeleteCustomKeyStoreCommand };
//# sourceMappingURL=DeleteCustomKeyStoreCommand.js.map